import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { QuestionType, AnimationOption } from 'library-explorer';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-question-boolean',
    templateUrl: './question-boolean.component.html',
    styleUrls: ['./question-boolean.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => QuestionBooleanComponent),
            multi: true
        }
    ],
    standalone: false
})
export class QuestionBooleanComponent implements ControlValueAccessor {
  @Input() animation: AnimationOption = AnimationOption.NONE;
  @Input() animationDelay = 0;
  @Input() questionHash: string;
  public disabled: boolean;
  @Input() isTwoColumn = false;

  public answers = [
    {
      hash: 1,
      text: this.translateService.instant('COMMON.true'),
    },
    {
      hash: 0,
      text: this.translateService.instant('COMMON.false'),
    }
  ];

  constructor(
    private translateService: TranslateService,
  ) { }

  public asnwer: any;

  onChange = (data: any) => { };
  onTouched = () => { };

  public selectAnswer(data: any) {
    if (!data) {
      this.onChange(null);
      return;
    }


    const selectedHash = data.answersHash[0];
    this.onChange({
      type: QuestionType.BOOLEAN_QUESTION,
      questionHash: this.questionHash,
      answer: selectedHash
    });
  }

  public writeValue(obj: any): void { }

  public registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
